export default __webpack_public_path__ + "static/versa-bf259681616b770cd26598ba9959379f.png";